import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { getAuth } from 'firebase/auth'
import { loadLegacyFirestore } from 'shared/firebase/loadLegacyFirebase'
import { backendForFirebaseUser } from './backendForFirebaseUser'

export const fetchPublicProfileData = async (handle) => {
    const normalizedHandle = normalizeHandle(handle)
    const backend = backendForFirebaseUser(getAuth(app).currentUser)
    if (backend) {
        try {
            const result = await backend.getProfile(normalizedHandle)
            return result.profile
        } catch (error) {
            if (error?.status === 404 || error?.code === 'profile_not_found') {
                return null
            }
            throw error
        }
    }

    const { collection, db, getDocs, query, where } =
        await loadLegacyFirestore()
    const field = typeof normalizedHandle === 'number' ? 'id' : 'nickname'
    const snapshot = await getDocs(
        query(collection(db, 'Auth'), where(field, '==', normalizedHandle))
    )
    const document = snapshot.docs[0]
    return document ? { ...document.data() } : null
}

const normalizeHandle = (handle) => {
    if (typeof handle === 'number') {
        if (!Number.isSafeInteger(handle) || handle < 0) {
            throw new TypeError('Profile handle is invalid')
        }
        return handle
    }

    const value = String(handle).trim()
    if (!value || value.length > 30) {
        throw new TypeError('Profile handle is invalid')
    }
    return value
}
